import { Space, Typography } from 'antd';
import styled from 'styled-components';

import { NeutralColors } from '@/theme/colors';

export const PopoverContainer = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: column;
`;

export const LabelContainer = styled.div`
  justify-content: space-between;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const PopoverContent = styled(Space)`
  width: 200px;
`;

export const TitleText = styled(Typography.Text)`
  font-size: 12px;
  color: ${NeutralColors[50]};
`;

export const LabelText = styled(Typography.Text)`
  font-size: 16px;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;
